module.exports = __webpack_public_path__ + "img/user-circle.9e7751f5.svg";